import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { SoundEnum } from "src/app/enums/sound.enum";
import { SoundService } from "../../services/common/sound.service";

@Injectable({
  providedIn: "root"
})
export class SnackBarService {
  constructor(
    private snackBar: MatSnackBar,
    private soundService: SoundService
  ) {}

  OpenSnackBar(
    message: string,
    action: string,
    duration: number,
    sound: SoundEnum
  ) {
    this.snackBar.open(message, action, {
      duration: duration
    });
    this.soundService.play(sound);
  }
}
